
import SectionHeader from './SectionHeader'
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '../../components/table'

import { format } from 'date-fns'
import { Loader2, Box } from 'lucide-react';
import { Avatar, AvatarImage } from '@univdiam/ui/components/avatar';
import { AvatarFallback } from '@radix-ui/react-avatar';


type CadDesignProps = {
    CADDesign: {
        id: string;
        fileName: string;
        bom: JSON;
        attachments: JSON;
        cost_price: string;
        selling_price: string;
        created_at: string;
        admin_name: string;
        admin_profile_pic: string;
    }[];
    isAdmin: boolean | null
    isOrderCadLoading: boolean | null,
    navigateToCadDesign: (id: string) => void

}


const CadDesign = ({ CADDesign, isAdmin, isOrderCadLoading, navigateToCadDesign }: CadDesignProps) => {
    return (
        <div className='flex flex-col bg-white border border-[#E9EAEB] rounded-md text-caption1 overflow-hidden'>
            <SectionHeader
                title="CAD Design"
                sectionIcon={<Box strokeWidth={1.5} className="w-5 h-5 text-gray-600" />}
                isAdmin={isAdmin}
            />
            <div className='text-body2 w-full'>
                {
                    isOrderCadLoading ? <div className='flex items-center my-2 w-full justify-center'>
                        <Loader2 className='animate-spin' />
                    </div> : CADDesign.length === 0 ? <p className='flex items-center justify-center my-6'>No CAD uploaded yet</p> : <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead className='px-4'>File Name</TableHead>
                                {/* <TableHead>Price</TableHead> */}
                                <TableHead>Upload Date</TableHead>
                                <TableHead>Uploaded By</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody className='text-body2'>
                            {
                                CADDesign && <>
                                    {CADDesign?.map((design, index) => (
                                        <TableRow key={index} className='my-2 cursor-pointer' onClick={() => {
                                            navigateToCadDesign(design.id)
                                        }}>
                                            <TableCell className='flex gap-2 items-center px-4'>
                                                {design.fileName}
                                            </TableCell>
                                            {/* <TableCell>{design.selling_price}</TableCell> */}
                                            <TableCell>{format(new Date(design.created_at), 'dd MMM yyyy')}</TableCell>
                                            <TableCell>
                                                <div className="flex items-center gap-2">
                                                    <Avatar className='w-[20px] h-[20px] rounded-[2px]'>
                                                        <AvatarImage src={design.admin_profile_pic} alt={design.admin_name} className='w-full rounded-[2px] h-full' />
                                                        <AvatarFallback className='flex items-center justify-center bg-gray-500 text-white w-full rounded-[2px] h-full'>{design.admin_name?.[0]}</AvatarFallback>
                                                    </Avatar>

                                                    {design.admin_name}
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </>
                            }
                        </TableBody>
                    </Table>
                }

            </div>
        </div>
    );
};

export default CadDesign;

